import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Auth } from 'aws-amplify'
import validator from 'validator'

import './SetNewPassword.sass'
import { InputMask } from '@/components/InputMask/InputMask'
import { Button } from '@/components/Button/Button'

export function SetNewPassword () {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [verificationCode, setVerificationCode] = useState({
    isValid: false,
    isClean: true,
    value: '',
  })
  const [newPassword, setNewPassword] = useState({
    isValid: false,
    isClean: true,
    value: '',
  })
  const [forgotMail, setForgotMail] = useState({
    isValid: false,
    isClean: true,
    value: '',
  })

  const history = useHistory()

  function updateForgotMail (value) {
    setForgotMail({
      isValid: validator.isEmail(value),
      isClean: false,
      value,
    })
  }

  function updateVerificationCode (value) {
    setVerificationCode({
      isValid: value.length > 5,
      isClean: false,
      value
    })
  }

  function updateNewPassword (value) {
    setNewPassword({
      isValid: /(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value),
      isClean: false,
      value
    })
  }

  function isFormValid () {
    return newPassword.isValid && verificationCode.isValid && forgotMail.isValid
  }

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const mail = query?.get('mail')

    if (mail?.length > 0) {
      setForgotMail({
        isValid: validator.isEmail(mail),
        isClean: false,
        value: mail
      })
    }
  }, [])

  function changePassword () {
    setIsSubmitting(true)
    Auth.forgotPasswordSubmit(forgotMail.value, verificationCode.value, newPassword.value)
      .then(() => {
        setIsSubmitting(false)
        history.push('/auth?code=set_password_success')
      })
      .catch(() => {
        setIsSubmitting(false)
        history.push('/auth?code=invalid_verification')
      })
  }

  return <div className="recover">
    <div className="recover__container">
      <div className="recover__container__text-input">
        <InputMask autocomplete="off" value={forgotMail.value} label="Backup email address" placeholder='Input the mail you used for registering' type="text" onInput={updateForgotMail} errorMessage={!forgotMail.isValid && !forgotMail.isClean && 'Please, set a valid email address.'}/>
      </div>
      <div className="recover__container__text-input">
        <InputMask autocomplete="off" value={newPassword.value} label="New password" helperTitle='Password requirements' placeholder='Input here your new password' helperMessage='We require your password to be 8 upper/lower characters but you can use symbols and numbers too. Please remember that longer passwords are more secure and can be easier to remember. Try grouping different words together to create a longer password.
Use unpredictable phrases that are funny or easy to remember.
Like StarWarsIsMyFav or BeatlesMusicDelivers or NotAllVioletsAreBlue -- be creative and original!' type="password" onInput={updateNewPassword} errorMessage={!newPassword.isValid && !newPassword.isClean && 'Password should have at least 8 characters combining uppercase and lowercase ones'}/>
      </div>
      <div className="recover__container__text-input">
        <InputMask autocomplete="off" value={verificationCode.value} label="Verification code" type="text" onInput={updateVerificationCode} errorMessage={!verificationCode.isValid && !verificationCode.isClean && 'Please, set a valid verification code.'}/>
      </div>
      <div className="recover__button">
        <Button content="Change password" size="large" disabled={!isFormValid() || isSubmitting} variant="outlined" click={changePassword} />
      </div>
    </div>
  </div>
}
